import React, { useState, useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import api from "../../../services/api";
import CakeAttributesTable from "./CakeAttributesTable";
import CakeAttributeFormDrawer from "./CakeAttributeFormDrawer";

const CakeAttributesPage = () => {
  const [attributes, setAttributes] = useState([]);
  const [selectedAttribute, setSelectedAttribute] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    fetchAttributes();
  }, []);

  const fetchAttributes = async () => {
    try {
      const response = await api.get("/cake-attributes");
      setAttributes(response.data);
    } catch (error) {
      console.error("Error fetching attributes:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/cake-attributes/${id}`);
      setAttributes(attributes.filter((attr) => attr._id !== id));
    } catch (error) {
      console.error("Error deleting attribute:", error);
    }
  };

  const handleSave = () => {
    fetchAttributes();
    setDrawerOpen(false);
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}>
        <Typography variant="h4" fontWeight={700}>
          Manage Cake Attributes
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => {
            setSelectedAttribute(null);
            setDrawerOpen(true);
          }}>
          Add Attribute
        </Button>
      </Box>

      <CakeAttributesTable
        attributes={attributes}
        onEdit={(attr) => {
          setSelectedAttribute(attr);
          setDrawerOpen(true);
        }}
        onDelete={handleDelete}
      />

      <CakeAttributeFormDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        onSave={handleSave}
        attributeData={selectedAttribute}
      />
    </Box>
  );
};

export default CakeAttributesPage;
